import React, {Component} from 'react'
import Button from '../../components/uiKit/Button'
import { Spring, config } from 'react-spring'



class ImportQuestionsFreeLimitMessage extends Component{

	showUpgrade(){
		window.location.hash='upgrade'
	}

	render(){	
		
		const {showFreeLimitMessage} = this.props

		return(					

			<Spring								
				to={{
          opacity: showFreeLimitMessage ? 1 : 0,
          yTranslate: showFreeLimitMessage ? 0 : 40,
        }}        
        //config={{ tension: 600, friction: 40 }}
      	>

        {props => 
        		<div 
        			style={{ transform: `translateY(${props.yTranslate}px)`, opacity:`${props.opacity}` }}
							className={'importQuestions-freeLimitMessage ' + (showFreeLimitMessage ? 'importQuestions-freeLimitMessage--show' : 'importQuestions-freeLimitMessage--hide')}
							onClick={this.showUpgrade}
						>						
							<div className='importQuestions-freeLimitMessage-title'>
								Free users are limited to 5 questions per set
							</div>
							<div className='importQuestions-freeLimitMessage-sub'>
								Learn about Plickers Pro
							</div>
							
					</div>
      	}					
			
			</Spring>


			
		)
	}
}


 
					



export default ImportQuestionsFreeLimitMessage



// WEBPACK FOOTER //
// ./src/components/importQuestions/ImportQuestionsFreeLimitMessage.js